<template>
  <div class="content-tab">
    <Content
      v-if="panels.length"
      :children="panels"
      :resizeable="!carousel"
      @positionChange="positionChanged"
      @click="setActive($event)"
      @delete="removePanel({ id: $event })"
      @resize="sizeChanged($event.id, $event.size)"
    />

    <Button
      v-if="(empty || panels.length) && carousel"
      icon="fas fa-plus"
      label="Adicionar depoimento"
      @click="addTestimonialPanel"
      class="content-tab__add-panel-button"
    />
    <Button
      v-else-if="empty || panels.length"
      icon="fas fa-plus"
      :label="$t('add-panel')"
      @click="addPanel({ parentId: id })"
      class="content-tab__add-panel-button"
    />

    <Button
      v-if="!isFromFunnel && (empty || panels.length)"
      icon="fas fa-plus"
      :label="$t('add-panel-with-form')"
      @click="batch('form', id)"
    />

    <WidgetSideNav v-if="widget" :parentId="id" :widget="widget" />

    <AddWidget v-if="empty" :parentId="id" />
  </div>
</template>

<script>
import ContentMixin from '@/components/sidenav/landing/shared/ContentMixin.js'
import WidgetSideNav from '@/components/sidenav/landing/panel/WidgetSideNav'
import AddWidget from '@/components/sidenav/landing/panel/AddWidget'
import Content from '@/components/sidenav/shared/Content'
import Button from '@/shared/components/Button'
import FunnelMixin from '@/components/Mixin'

export default {
  name: 'PanelSideNavContentTab',
  i18nOptions: { keyPrefix: 'components.sidenav.landing.panel.content' },
  mixins: [ContentMixin, FunnelMixin],
  components: { AddWidget, Content, Button, WidgetSideNav },
  props: {
    carousel: {
      type: Boolean,
      default: false,
    },
    path: {
      type: Array,
      default() {
        return []
      },
    },
    panels: {
      type: Array,
      default() {
        return []
      },
    },
    widget: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    async addTestimonialPanel() {
      const newPanelId = await this.addPanel({
        parentId: this.id,
      })

      this.addPanel({
        parentId: newPanelId,
        widget: {
          type: 'Image',
          options: {
            originalUrl: this.$options.carouselImageUrl,
            url: this.$options.carouselImageUrl,
            width: 164,
            height: 164,
            staticImg: false,
            style: {
              scss: '',
              css: null,
            },
          },
        },
      })

      this.addPanel({
        parentId: newPanelId,
        panelSize: 6,
        scrollIntoView: false,
        widget: { type: 'Text', options: { content: this.$options.carouselPanelContent } },
      })
    },
  },
  computed: {
    empty() {
      return !this.panels.length && !this.widget
    },
  },
  carouselPanelContent:
    '<p class="ql-align-center"><strong style="font-size: 18px; color: rgb(255, 255, 255);">Maria Eduarda</strong></p><p class="ql-align-center"><br></p><p class="ql-align-center"><em style="color: rgb(255, 255, 255);">"We have already a clue. There can be no doubt that the probability - the strong probability - is that the writer was on board of a ship. And now let us consider another point. In the case of Pondicherry, seven weeks elapsed between the threat and its fulfilment."</em></p>',
  carouselImageUrl:
    'https://eadbox-tmp-staging.s3.amazonaws.com/temp%2F5c8a9cae95d6fa003763b5fc%2Fdepoimento_2%402x.png',
}
</script>

<style lang="scss" scoped>
.content-tab {
  padding: 8px;
}

.content-tab__add-panel-button {
  margin-top: 16px;
  margin-bottom: 24px;
}
</style>
